export default {
    margin: 1,
};
